import { SET_WARRANTY_DATA } from './types';

export const setWarrantyData = (data) => ({
  type: SET_WARRANTY_DATA,
  payload: data,
});
